import { render, staticRenderFns } from "./ApplicationExchangeDialog.vue?vue&type=template&id=5c839fb2&scoped=true"
import script from "./ApplicationExchangeDialog.vue?vue&type=script&lang=js"
export * from "./ApplicationExchangeDialog.vue?vue&type=script&lang=js"
import style0 from "./ApplicationExchangeDialog.vue?vue&type=style&index=0&id=5c839fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c839fb2",
  null
  
)

export default component.exports